// TODO expose offset/samples as uniforms/props (and if even wanted)

// colorShift & chromaticAberration based on https://mini.gmshaders.com/p/gm-shaders-mini-chromatic-aberration
vec4 colorShift(sampler2D tex, vec2 uvCoord, vec2 offset) {
    vec4 color = vec4(1.0);

    color.r = texture(tex, uvCoord - offset).r;
    color.g = texture(tex, uvCoord).g;
    color.b = texture(tex, uvCoord + offset).b;

    return color;
}

// WARN samples must be even number!
vec4 chromaticAberration(sampler2D tex, vec2 uvCoord, vec2 offset, float samples) {
    vec4 color_sum = vec4(0);
    vec4 weight_sum = vec4(0);

    for (float i = 0.; i <= 1.; i += 1. / samples) {
        vec2 coord = uvCoord + (i - .5) * offset;
        vec4 color = texture(tex, coord);
        vec4 weight = vec4(i, 1. - abs(i * 2. - 1.), 1. - i, .5);
        color_sum += color * color * weight;
        weight_sum += weight;
    }

    return sqrt(color_sum / weight_sum);
}

// #define OFFSET vec2(0.0025,0.0025) // colorShift vals
// #define OFFSET vec2(0.0075,0.0075) // chromaticAberration vals
#define SAMPLES 4.0

uniform sampler2D streaks;

// mainImage; outputColor etc, because shader needs to conform to Effect's terminology/given variables
void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
    outputColor = chromaticAberration(streaks, uv, vec2(0.0075, 0.0075), SAMPLES); // slightly blurrier but better looking
    // outputColor = colorShift(streaks, uv, vec2(0.0025, 0.0025));

    // debug views
    // outputColor = vec4(inputColor.rgb + texture(streaks, uv).rgb, 1.); // Add input + streaks, should not be necessary because we blend ADD with previous EffectPass
    // outputColor = vec4(inputColor.rgb, 1.); // Effect's input from previous EffectPass (? still a little obtuse what exactly gets passed in)
    // outputColor = vec4(texture(streaks, uv).rgb, 1.); // just streaks Pass output, set blend to SRC to see output
}
